export default {
  label: 'Categoría',
  placeholder: 'Ninguno',
};
